import React from 'react';
import {SCRIPT_TYPE_OPTIONS} from '../../../constants/scriptTypeOptions';
import ProjectBasicsForm from '../../shared/ProjectBasicsForm';

interface ScriptTypeSelectorProps {
  testID?: string;
  selectedValues: string[];
  onValueSelect: (value: string) => void;
}

function ScriptTypeSelector({
  testID = 'script-type-selector',
  selectedValues,
  onValueSelect,
}: ScriptTypeSelectorProps) {
  return (
    <ProjectBasicsForm
      testID={testID}
      showTextInput={false}
      chipOptions={SCRIPT_TYPE_OPTIONS}
      selectedValues={selectedValues}
      onValueSelect={onValueSelect}
      chipSectionLabel="Script type"
    />
  );
}

export default ScriptTypeSelector;
